import { render } from "./AgentChat.vue?vue&type=template&id=0eaf8a19"
import script from "./AgentChat.vue?vue&type=script&lang=js"
export * from "./AgentChat.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__